import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Button, Card, Col, Form, message, Modal, Row, Table } from 'antd';
import DateRangePicker from '../../../components/common/date-range-picker';
import { currencyVND, dateToString } from '../../../utils';
import * as CommonService from '../../../services/CommonService';
import { REPORT_ENDPOINT } from '../../../services/endpoint';
import moment from 'moment/moment';

const RevenueChart = () => {
	// const last30Days = [moment().subtract(29, 'days'), moment()];

	const [report, setReport] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [detailByDay, setDetailByDay] = useState(null);
	const [totalRevenue, setTotalRevenue] = useState(0);
	const [totalProfit, setTotalProfit] = useState(0);
	const [searchValues, setSearchValues] = useState({
		orderReportType: 'TODAY',
		startDate: moment().format('YYYY-MM-DD'),
		endDate: moment().format('YYYY-MM-DD')
	});

	const [pagination, setPagination] = useState({
		current: 1,
		pageSize: 20,
		showSizeChanger: true,
		pageSizeOptions: [ '5', '10', '20', '30', '50', '100'],
		showTotal: (total, range) => `${range[0]}-${range[1]} trong ${total} kết quả`
	});

	const [dataChart, setDataChart] = useState({
		labels: [],
		datasets: [
			{
				type: 'bar',
				label: 'Doanh thu',
				data: [],
				backgroundColor: '#FF7675',
				borderRadius: 4
			},
			{
				type: 'bar',
				label: 'Lợi nhuận',
				data: [],
				backgroundColor: '#74B9FF',
				borderRadius: 4
			}
		]
	});

	useEffect(() => {
		if (report.length) {
			let total = 0;
			let totalProfit = 0;
			const labels = report.map((item) => dateToString(item.orderDate, 'DD-MM-YYYY'));
			const data = report.map((item) => {
				total += item.revenue;
				return item.revenue;
			});
			const data1 = report.map((item) => {
				totalProfit += item.profit;
				return item.profit;
			});
			setTotalRevenue(total);
			setTotalProfit(totalProfit);
			setDataChart({
				...dataChart,
				labels,
				datasets: [{ ...dataChart.datasets[0], data }, { ...dataChart.datasets[1], data: data1 }]
			});
		}
	}, [report]);

	const options = {
		responsive: true,
		maintainAspectRatio: false,
		tooltips: {
			mode: 'index',
			intersect: false,
			callbacks: {
				label: function(tooltipItem, data) {
					let label = data.datasets[tooltipItem.datasetIndex].label || '';
					if (label) {
						label += ': ';
					}
					label += new Intl.NumberFormat('vi-VN', {
						style: 'currency',
						currency: 'VND'
					}).format(tooltipItem.yLabel);
					return label;
				}
			}
		},
		legend: {
			position: 'bottom'
		},
		scales: {
			yAxes: [
				{
					ticks: {
						callback: function(value) {
							return value.toLocaleString('vi-VN');
						}
					}
				}
			]
		}
	};

	const init = async () => {
		try {
			window.setLoading(true);
			const res = await CommonService.post(
				`${REPORT_ENDPOINT}/order-report-for-date`,
				searchValues
			);
			if (res.status === 200) {
				setReport(res.data || []);
			}
		} catch (e) {
			message.error('Có lỗi xảy ra: ' + e);
		} finally {
			window.setLoading(false);
		}
	};

	useEffect(() => {
		init();
	}, []);

	useEffect(() => {
		init();
	}, [searchValues]);

	const handleChange = (value, key) => {
		searchValues[key] = value;
		setSearchValues({ ...searchValues });
	};

	// ✅ cập nhật page / pageSize khi thay đổi
	const handleTableChange = (pag) => {
		setPagination({
			...pagination,
			current: pag.current,
			pageSize: pag.pageSize
		});
	};

	const onClickOrderDate = async (text) => {
		try {
			window.setLoading(true);
			const res = await CommonService.get(`${REPORT_ENDPOINT}/order-report-for-date/${dateToString(text, 'YYYY-MM-DD')}`);
			if (res.status === 200) {
				setDetailByDay(res.data || []);
				setShowModal(true);
			}
		} catch (e) {
			message.error('Có lỗi xảy ra: ' + e);
		} finally {
			window.setLoading(false);
		}
	}
	const columns = [
		{
			title: 'Ngày',
			dataIndex: 'orderDate',
			width: 140,
			align: 'center',
			render: (text) => <Button type={'link'} onClick={() => onClickOrderDate(text)}>
				{dateToString(text, 'DD-MM-YYYY')}
			</Button>
		},
		{
			title: 'SL đơn hàng',
			dataIndex: 'orderQuantity',
			width: 100,
			align: 'center'
		},
		{
			title: 'Tiền hàng',
			dataIndex: 'totalAmount',
			align: 'center',
			width: 150,
			render: (text) => currencyVND(text)
		},
		{
			title: 'Tiền hàng trả lại',
			dataIndex: 'totalRefund',
			align: 'center',
			width: 150,
			render: (text) => currencyVND(text)
		},
		{
			title: 'Doanh thu',
			dataIndex: 'revenue',
			width: 200,
			align: 'center',
			render: (text) => <span style={{color: 'red'}}>{currencyVND(text)}</span>
		},
		{
			title: 'Lợi nhuận',
			dataIndex: 'profit',
			width: 200,
			align: 'center',
			render: (text) => <span style={{color: 'blue'}}>{currencyVND(text)}</span>
		}
	];

	const columnsDetail = [
		{
			title: 'Thời gian',
			dataIndex: 'orderDate',
			width: 140,
			align: 'center',
			render: (text) => dateToString(text, 'DD-MM-YYYY HH:mm:ss')
		},
		{
			title: 'SL đơn hàng',
			dataIndex: 'orderQuantity',
			width: 100,
			align: 'center'
		},
		{
			title: 'Tiền hàng trả lại',
			dataIndex: 'totalRefund',
			align: 'center',
			width: 150,
			render: (text) => currencyVND(text)
		},
		{
			title: 'Doanh thu',
			dataIndex: 'revenue',
			width: 200,
			align: 'center',
			render: (text) => <span style={{color: 'red'}}>{currencyVND(text)}</span>
		},
		{
			title: 'Lợi nhuận',
			dataIndex: 'profit',
			width: 200,
			align: 'center',
			render: (text) => <span style={{color: 'blue'}}>{currencyVND(text)}</span>
		}
	];

	return (
		<>
			<Card title={'Hoạt động kinh doanh'}>
				<Row>
					<Col span={8}>
						<Form>
							<Form.Item label="Chọn khoảng thời gian">
								<DateRangePicker
									style={{ width: 250 }}
									format="DD/MM/YYYY"
									onChange={(value) => {
										const arr = value.map((el) =>
											dateToString(el, 'YYYY-MM-DD')
										);
										handleChange(arr[0], 'startDate');
										handleChange(arr[1], 'endDate');
									}}
									allowClear={false}
								/>
							</Form.Item>
						</Form>
					</Col>
					<Col span={8}>
						<Form.Item label="Doanh thu">
							<b style={{color: 'red'}}>{currencyVND(totalRevenue)}</b>
						</Form.Item>
					</Col>
					<Col span={8}>
						<Form.Item label="Lợi nhuận"><b style={{color: 'blue'}}>{currencyVND(totalProfit)}</b></Form.Item>
					</Col>
				</Row>
				<div style={{ height: 300, padding: 20 }}>
					<Bar data={dataChart} options={options} />
				</div>
			</Card>

			<Card className={'mt-20'}>
				<Table
					rowKey={(record, index) => index}
					bordered={false}
					dataSource={report}
					columns={columns}
					pagination={{
						...pagination,
						total: report.length
					}}
					onChange={handleTableChange}
				/>
			</Card>
			<Modal title={'Chi tiết theo ngày'} visible={showModal} onCancel={() => {
				setShowModal(false)
				setDetailByDay(null)
			}} footer={null} width={1200}>
				<Table bordered={true}
										 dataSource={detailByDay}
										 columns={columnsDetail}
										 pagination={false}
				/>
			</Modal>
		</>
	);
};

export default RevenueChart;
